import { html } from "../../base/_utils";
import { staffModal } from "./_staff-modal";

export function staffCard(member, path) {
    return html`
        <div class="staff-card card staff-member h-100 fade-in overflow-hidden z-1">
            <button class="staff-modal-trigger border-0 shadow-none p-0" data-bs-toggle="modal" data-bs-target="#${member.id}-modal">
                <div class="bio-banner bg-secondary-opaque d-flex flex-column justify-content-center align-items-center">
                    <img alt="Friar logo" class="staff-hover-logo img-fluid w-50" src="${path}assets/media/logos/logo-friar-head.svg" />
                    <p class="display-6 font-weight-bold mt-3">View Bio</p>
                </div>
            </button>
            <img class="staff-image card-img-top" src="${path}${member.image}" alt="${member.name} headshot" />
            <div class="card-footer h-100 text-center py-3  d-flex flex-column justify-content-center">
                <h3 class="staff-name h6">${member.name}</h3>
                <p class="staff-title">${member.title}</p>
            </div>
        </div>
        ${staffModal(member, path)}
    `;
}
